import type { TicketStatus } from '../types/tickets/types';

type TicketStatusPresentation = {
  labelKey: string;
  tagClassName: string;
  chipColor: 'default' | 'error' | 'info' | 'primary' | 'secondary' | 'success' | 'warning';
};

const STATUS_PRESENTATIONS: Record<TicketStatus, TicketStatusPresentation> = {
  pendente: { labelKey: 'notifications.requester.status.pendente', tagClassName: 'tag is-warning', chipColor: 'warning' },
  aceito: { labelKey: 'notifications.requester.status.aceito', tagClassName: 'tag is-link', chipColor: 'primary' },
  emandamento: { labelKey: 'notifications.requester.status.em_andamento', tagClassName: 'tag is-info', chipColor: 'info' },
  em_andamento: { labelKey: 'notifications.requester.status.em_andamento', tagClassName: 'tag is-info', chipColor: 'info' },
  concluido: { labelKey: 'notifications.requester.status.concluido', tagClassName: 'tag is-success', chipColor: 'success' },
  recusado: { labelKey: 'notifications.requester.status.recusado', tagClassName: 'tag is-danger', chipColor: 'error' },
  cancelado: { labelKey: 'notifications.requester.status.cancelado', tagClassName: 'tag is-danger', chipColor: 'error' },
  fechado: { labelKey: 'notifications.requester.status.fechado', tagClassName: 'tag is-dark', chipColor: 'default' },
  fechadoDuplicidade: { labelKey: 'notifications.requester.status.fechadoDuplicidade', tagClassName: 'tag is-dark', chipColor: 'default' },
  fechadoCancelamento: { labelKey: 'notifications.requester.status.fechadoCancelamento', tagClassName: 'tag is-warning', chipColor: 'warning' },
  fechadoRecusa: { labelKey: 'notifications.requester.status.fechadoRecusa', tagClassName: 'tag is-danger', chipColor: 'error' },
  reaberto: { labelKey: 'notifications.requester.status.reaberto', tagClassName: 'tag is-primary', chipColor: 'secondary' },
  aprovado: { labelKey: 'notifications.requester.status.aprovado', tagClassName: 'tag is-success', chipColor: 'success' },
};

export const getTicketStatusPresentation = (status: string | null | undefined) =>
  status ? STATUS_PRESENTATIONS[status as TicketStatus] : undefined;
